/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxWaterDropIcon24Solid = forwardRef('NatureFxWaterDropIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.988 2.173a1.454 1.454 0 0 1 2.024 0c.849.818 2.636 2.63 4.216 4.81 1.556 2.147 3.022 4.797 3.022 7.267a8.25 8.25 0 0 1-16.5 0c0-2.47 1.465-5.12 3.021-7.267 1.58-2.18 3.368-3.992 4.217-4.81Zm6.13 11.812c-.066-1.288-2.064-1.184-1.997.104.096 1.87-1.565 3.442-3.407 3.273-1.284-.118-1.466 1.874-.182 1.992 3.057.28 5.745-2.302 5.586-5.369Z" })));
});
